// Generated by scripts/sync-catalog-sitemap.mjs - do not edit by hand.
// Re-run: pnpm sync:catalog-sitemap
export const providersSlugMap = {
    "1x2gaming": "1X2gaming",
    "adlunam": "AdLunam",
    "avatarux": "AvatarUX",
    "aviator": "Aviator",
    "aviatrix": "Aviatrix",
    "bang-bang-games": "Bang Bang Games",
    "betgames": "BetGames",
    "bgaming": "BGaming",
    "big-time-gaming": "Big Time Gaming",
    "bigpot-gaming": "Bigpot Gaming",
    "blueprint-gaming": "Blueprint Gaming",
    "boominggames": "BoomingGames",
    "bulletproof-games": "Bulletproof Games",
    "creedroomz": "Creedroomz",
    "electric-elephant": "Electric Elephant",
    "endorphina": "Endorphina",
    "evolution": "Evolution",
    "expanse-studios": "Expanse Studios",
    "fantasma": "Fantasma",
    "fbastards": "Fbastards",
    "fbmds": "FBMDS",
    "flush-originals": "Flush Originals",
    "four-leaf-gaming": "Four Leaf Gaming",
    "gameart": "GameArt",
    "gametech": "GameTech",
    "gamevy": "Gamevy",
    "gamingcorps": "GamingCorps",
    "habanero": "Habanero",
    "hacksaw-gaming": "Hacksaw Gaming",
    "high-5-games": "High 5 Games",
    "hot-rise-games": "Hot Rise Games",
    "irondog": "IronDog",
    "jili-games": "Jili Games",
    "libertyspins": "Libertyspins",
    "live-solutions": "Live Solutions",
    "manna-play": "Manna Play",
    "max-win-gaming": "Max Win Gaming",
    "maxxilabs": "Maxxilabs",
    "mg-live": "MG Live",
    "microgaming-live": "MicroGaming Live",
    "million-games": "Million Games",
    "netent": "NetEnt",
    "nolimit-city": "Nolimit City",
    "novomatic": "Novomatic",
    "onetouch": "Onetouch",
    "peter-and-sons": "Peter & Sons",
    "pgsoft": "PGSoft",
    "playson": "Playson",
    "playzia": "Playzia",
    "pragmatic-play": "Pragmatic Play",
    "pragmatic-play-live": "Pragmatic Play Live",
    "print-studios": "Print Studios",
    "prospectgaming": "ProspectGaming",
    "quickspin": "Quickspin",
    "ready-play-gaming": "Ready Play Gaming",
    "red-tiger-gaming": "Red Tiger Gaming",
    "reelplay": "ReelPlay",
    "reflex-gaming": "Reflex Gaming",
    "relax-gaming": "Relax Gaming",
    "rogue-gaming": "Rogue Gaming",
    "sgaming": "SGaming",
    "shadylady": "Shadylady",
    "slot-factory": "Slot Factory",
    "slotmill": "Slotmill",
    "solvited": "Solvited",
    "storm-gaming": "Storm Gaming",
    "thunderkick": "Thunderkick",
    "tomhorn": "TomHorn",
    "topspin": "Topspin",
    "trigger": "Trigger",
    "twainsport": "TwainSport",
    "wazdan": "Wazdan",
    "wickedgames": "Wickedgames",
    "winfast": "Winfast",
    "yggdrasil-gaming": "Yggdrasil Gaming",
};
